import namespace from '../namespace'

export default namespace('auth', {
  getters: [
    'getToken',
    'getUser',
  ],
  mutations: [
    'signInRequest',
    'signInSuccess',
    'signInFailure',
    'signUpRequest',
    'signUpSuccess',
    'signUpFailure',
    'logout',
  ],
  actions: [
    'setUser',
    'signIn',
    'signUp',
    'logout',
  ],
})
